import { render, staticRenderFns } from "./PromoPeriod.vue?vue&type=template&id=03d20d5c&scoped=true&"
import script from "./PromoPeriod.vue?vue&type=script&lang=js&"
export * from "./PromoPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d20d5c",
  null
  
)

export default component.exports